import React, { useEffect, useState } from 'react'
import CustomNavItem from '@ferrodo-computer/custom-nav-item'
import useGetSimilarProducts from '../../Shop/Hooks/useGetSimilarProducts'
import useGetRelatedProducts from '../../Shop/Hooks/useGetRelatedProducts'
import useGetProductsBySerial from '../../Shop/Hooks/useGetProductsBySerial'
import LoadingSpinner from '../../../Components/Components/LoadingSpinner'
import CustomSwiper from '../../../Components/Components/CustomSwiper'

const SingleProductAdditionalProducts = ({ product, handleProductClick }) => {
    const [tabs, setTabs] = useState([])
    const [activeTab, setActiveTab] = useState('')
    const [additionalProducts, setAdditionalProducts] = useState([])
    const [loadingData, setLoadingData] = useState(true)

    const { similarProducts, isSimilarProductsLoading } = useGetSimilarProducts(product)
    const { relatedProducts, isRelatedProductsLoading } = useGetRelatedProducts(product)
    const { productsWithSameSerial, isProductsWithSameSerialLoading } = useGetProductsBySerial(product)

    useEffect(() => {
        if (isSimilarProductsLoading || isRelatedProductsLoading || isProductsWithSameSerialLoading) {
            setLoadingData(true)
        }
        else {
            setLoadingData(false)
        }
    }, [isSimilarProductsLoading, isRelatedProductsLoading, isProductsWithSameSerialLoading])

    useEffect(() => {
        if (product) {
            let newTabs = []
            if (product.hasRelated) {
                newTabs.push('Powiązane')
            }
            if (product.hasSimilar) {
                newTabs.push('Podobne')
            }
            if (product.hasSeries) {
                newTabs.push('Seria')
            }
            setTabs(newTabs)
            setActiveTab(newTabs[0])
        }
    }, [product])

    useEffect(() => {
        switch (activeTab) {
            case 'Powiązane':
                setAdditionalProducts(relatedProducts)
                break;
            case 'Seria':
                setAdditionalProducts(productsWithSameSerial)
                break;
            case 'Podobne':
                setAdditionalProducts(similarProducts)
                break;
            default:
                setAdditionalProducts([])
                break;
        }
    }, [activeTab, relatedProducts, productsWithSameSerial, similarProducts])

    const generateContent = () => {
        if (loadingData) {
            return <LoadingSpinner />
        }
        if (!additionalProducts || additionalProducts.length === 0) {
            return null
        }
        return (
            <CustomSwiper
                products={additionalProducts}
                header={''}
                loop={true}
                refreshPage={false}
                autoPlay={false}
                slidesPerView={5}
                handleProductClick={handleProductClick}
            />
        )
    }

    if (!tabs || tabs.length === 0) {
        return null
    }
    return (
        <>
            <div className="container">
                <CustomNavItem
                    items={tabs}
                    defaultItem={activeTab}
                    onClick={(item) => setActiveTab(item)}
                    isFullWidth={false}
                />
            </div>
            <div className="container-fluid" style={{ backgroundColor: 'var(--body-background-dark)', marginTop: '-10px' }}>
                <div className="container">
                    {generateContent()}
                </div>
            </div>
        </>
    )
}

export default SingleProductAdditionalProducts